import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/aivoice/ico_chuantouxiang.svg'
import _imports_1 from '@/assets/imgcaptions/selOff.png'
import _imports_2 from '@/assets/imgcaptions/selOn.png'


const _hoisted_1 = { class: "rolesEdit" }
const _hoisted_2 = { class: "rolesEditTitle" }
const _hoisted_3 = { class: "rolesEditImg" }
const _hoisted_4 = { class: "editImg" }
const _hoisted_5 = { class: "editImgBox" }
const _hoisted_6 = { class: "editImgBoxInner" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "editImg" }
const _hoisted_10 = { class: "editName" }
const _hoisted_11 = {
  key: 0,
  class: "rolesEditTts"
}
const _hoisted_12 = { class: "rolesTts" }
const _hoisted_13 = { class: "rolesTtsSel" }
const _hoisted_14 = { class: "selTtsOne" }
const _hoisted_15 = { class: "roleLeft" }
const _hoisted_16 = { class: "roleLeftImg" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "roleLeftTitle" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "maskTts" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_24 = { class: "piecedelBox" }
const _hoisted_25 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_26 = { class: "confirmBox" }
const _hoisted_27 = { class: "titleBox" }
const _hoisted_28 = { class: "textBox" }
const _hoisted_29 = { class: "btnBox" }

import { ref, onMounted,getCurrentInstance,nextTick} from 'vue'
import {
    Close,
} from "@element-plus/icons-vue";
import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";
import {captionTtsStore} from "@/store/captionTts.ts"
import depotApi from "@/api/sound/depot.ts";
// 引入音色市场模块
import timbreMarket from "./timbreMarket.vue"
import { uploadFileCommon } from '@/components/common/fileTypeUpload.ts';

import headPic from '@/assets/aivoice/ico_morentouxiang.svg';

export default /*@__PURE__*/_defineComponent({
  __name: 'roleEdit',
  props: {
        roleOne:Object
},
  emits: ['closeThis','editRoleImgfun'],
  setup(__props, { emit: __emit }) {

let { proxy } = getCurrentInstance()
const token = Auth.getToken();
const ttstore=captionTtsStore()
//接口引入
const rolesttsOpen=ref(false)
const marketShow=ref(false)//音色市场
const confirmShow=ref(false)//确认弹窗
const vimData = {
  host: FetchRequest.getHost(),
  headers: {
    "Access-Control-Allow-Origin": "*",
    Authorization: "Bearer " + token,
  },
  data: {
    access_token: Auth.getToken(),
    type: "file",
  },
};
const emit = __emit

// 获取角色，默认选择公开角色第一个
const showRoleOne=ref('')
const getPublic=()=>{
    depotApi.getList(1, 5,1).then((res) => {
        // roleList.value = res.rows;
        console.log(res.rows[0])
        showRoleOne.value=res.rows[0]
        
    });
}
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}
const props = __props
const roleInit=ref({
        "avatar": "",
        "id": "",
        "name": "",
        'enableTTS':false,
})
const handleSuccess = (response: any) => {
    
    // roleInit.value.avatar=response.fileName
    roleInit.value.avatar=response.msg
};
const uploadFileCommonFun = (file: any) => {
    console.log(file)
  
    uploadFileCommon(file, 'avatar',0).then((res: any) => {
        console.log('上传成功返回')
        console.log(res)
        if(res.code==200){
            roleInit.value.avatar=res.data.url
            upData()
        }
        
    });
};
// 启用禁用TTS
const enableTTSFun=(data:boolean)=>{
    console.log(roleInit.value)
    if(roleInit.value.status!=undefined&&roleInit.value.status==1){
        return
    }
    rolesttsOpen.value=data
    roleInit.value.enableTTS=data
    upData()
}
//保存信息
const upData=()=>{
    console.log(roleInit.value)
    emit('editRoleImgfun',JSON.stringify(roleInit.value))
} 
const voiceRoles=ref([])
onMounted(()=>{
    const initRoleData=JSON.parse(JSON.stringify(props.roleOne))
    roleInit.value={...roleInit.value, ...initRoleData}
    console.log('初始化角色数据')
    console.log(initRoleData)
    console.log(roleInit.value)
    voiceRoles.value=ttstore.voiceRoles
    console.log(voiceRoles.value)
    if(initRoleData.voiceRoleId==undefined){
        getPublic()   
    }else{
        console.log(voiceRoles.value.filter(it=>it.roleId==initRoleData.voiceRoleId)[0])
        showRoleOne.value=voiceRoles.value.filter(it=>it.roleId==initRoleData.voiceRoleId)[0]
    }
    
})

// 选择音色
const choseRole=ref('')
const recognition=(data:any)=>{
    console.log('选择的音色')
    console.log(data)
    choseRole.value=JSON.parse(data) 
    marketShow.value=false
    confirmShow.value=true
}
const choseRolefun=()=>{
    console.log('确认选择音色')
    console.log(choseRole.value)
    showRoleOne.value={...showRoleOne.value,...choseRole.value}
    console.log(showRoleOne.value)
    roleInit.value.voiceRoleId=showRoleOne.value.roleId
    roleInit.value.status=1
    // console.log(delete roleInit.value.status)
    let data= roleInit.value
    delete data.status
    // console.log( data)
    emit('editRoleImgfun',JSON.stringify( data))
    emit('closeThis')
    // roleInit.value.voiceRoleId=choseRole.value.id
    // roleInit.value.voiceRoleName=choseRole.value.name
    // roleInit.value.voiceRoleAvatar=choseRole.value.avatar
    // upData()
    confirmShow.value=false
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("span", null, "编辑角色", -1)),
      _createElementVNode("span", {
        class: "closeBtn",
        onClick: _withModifiers(closeBox, ["stop"])
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "editImgTitle" }, " 角色头像 ", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_upload, {
            "show-file-list": false,
            multiple: "",
            "auto-upload": false,
            onChange: uploadFileCommonFun
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (roleInit.value.avatar==undefined||roleInit.value.avatar=='')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(headPic),
                      class: "editImgHead"
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true),
                (roleInit.value.avatar!=undefined&&roleInit.value.avatar!='')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _unref(proxy).getimgUrl+roleInit.value.avatar,
                      class: "editImgHead"
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _cache[8] || (_cache[8] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  class: "editImgBtn"
                }, null, -1))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "editImgTitle" }, " 角色名称 ", -1)),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入角色名称",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((roleInit.value.name) = $event)),
            onBlur: upData
          }, null, 544), [
            [_vModelText, roleInit.value.name]
          ])
        ])
      ])
    ]),
    (_unref(ttstore).isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[11] || (_cache[11] = _createElementVNode("span", null, "幻音TTS", -1)),
            _withDirectives(_createElementVNode("img", {
              src: _imports_1,
              alt: "",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (enableTTSFun(true)), ["stop"]))
            }, null, 512), [
              [_vShow, !roleInit.value.enableTTS]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _imports_2,
              alt: "",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (enableTTSFun(false)), ["stop"]))
            }, null, 512), [
              [_vShow, roleInit.value.enableTTS]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("img", {
                    src: _unref(proxy).getimgUrlVoice + showRoleOne.value.avatar
                  }, null, 8, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(showRoleOne.value.name), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(showRoleOne.value.intro), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: "roleright",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (marketShow.value = true), ["stop"]))
              }, _toDisplayString(roleInit.value.voiceRoleId!=undefined ? '更换音色' : '选择音色'), 1)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_21, [
              (roleInit.value.status!=undefined&&roleInit.value.status==1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "幻音TTS 配音生成中..."))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, !roleInit.value.enableTTS||(roleInit.value.status!=undefined&&roleInit.value.status!=100)]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (marketShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(timbreMarket, {
                isChange: false,
                onCloseThis: _cache[4] || (_cache[4] = ($event: any) => (marketShow.value = false)),
                onRecognition: recognition
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (confirmShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[12] || (_cache[12] = _createElementVNode("span", null, "幻音TTS", -1)),
                _createVNode(_component_el_icon, {
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (confirmShow.value=false), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Close))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_28, " 请确认是否将 “" + _toDisplayString(roleInit.value.name) + "” 的音色替换成 “" + _toDisplayString(choseRole.value.name) + "” 确认后将立刻开始配音生成！ ", 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", {
                  class: "noBtn",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (confirmShow.value=false), ["stop"]))
                }, "取消"),
                _createElementVNode("div", {
                  class: "okBtn",
                  onClick: _withModifiers(choseRolefun, ["stop"])
                }, "确定")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})